exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SignButton{border-radius:32px;margin-top:24px}", ""]);
